import { render } from "./Launch.vue?vue&type=template&id=39faaf4e"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"
script.render = render

export default script